"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionEndOfPeriodProcessingResult = exports.PaymentToolOptions = exports.SubscriptionExtensionPackageStatus = exports.SubscriptionStatusEnum = exports.SubscriptionIntervalEnum = exports.SubscriptionOptionEnum = exports.SubscriptionLevelEnum = void 0;
var SubscriptionLevelEnum;
(function (SubscriptionLevelEnum) {
    SubscriptionLevelEnum["BASIC"] = "BASIC";
    SubscriptionLevelEnum["STARTER"] = "STARTER";
    SubscriptionLevelEnum["SCALE_UP"] = "SCALE_UP";
    SubscriptionLevelEnum["PROFESSIONAL"] = "PROFESSIONAL";
    SubscriptionLevelEnum["ENTERPRISE"] = "ENTERPRISE";
})(SubscriptionLevelEnum = exports.SubscriptionLevelEnum || (exports.SubscriptionLevelEnum = {}));
var SubscriptionOptionEnum;
(function (SubscriptionOptionEnum) {
    SubscriptionOptionEnum["TOOLKIT"] = "TOOLKIT";
    SubscriptionOptionEnum["TOOLKIT_MOBILE"] = "TOOLKIT_MOBILE";
    SubscriptionOptionEnum["PAYMENTS_ONLY"] = "PAYMENTS_ONLY";
    SubscriptionOptionEnum["PAYMENTS_ONLY_EU"] = "PAYMENTS_ONLY_EU";
    SubscriptionOptionEnum["SHOPIFY_B2B_SUBSCRIPTION"] = "SHOPIFY_B2B_SUBSCRIPTION";
})(SubscriptionOptionEnum = exports.SubscriptionOptionEnum || (exports.SubscriptionOptionEnum = {}));
var SubscriptionIntervalEnum;
(function (SubscriptionIntervalEnum) {
    SubscriptionIntervalEnum["MONTH"] = "MONTH";
    SubscriptionIntervalEnum["YEAR"] = "YEAR";
})(SubscriptionIntervalEnum = exports.SubscriptionIntervalEnum || (exports.SubscriptionIntervalEnum = {}));
var SubscriptionStatusEnum;
(function (SubscriptionStatusEnum) {
    //stripe statuses
    SubscriptionStatusEnum["active"] = "active";
    SubscriptionStatusEnum["past_due"] = "past_due";
    SubscriptionStatusEnum["unpaid"] = "unpaid";
    SubscriptionStatusEnum["canceled"] = "canceled";
    SubscriptionStatusEnum["incomplete"] = "incomplete";
    SubscriptionStatusEnum["incomplete_expired"] = "incomplete_expired";
    SubscriptionStatusEnum["trialing"] = "trialing";
    SubscriptionStatusEnum["paused"] = "paused";
    // custom statuses
    SubscriptionStatusEnum["deleted"] = "deleted";
    SubscriptionStatusEnum["payment_action_required"] = "payment_action_required";
    SubscriptionStatusEnum["payment_failed"] = "payment_failed";
    SubscriptionStatusEnum["processing"] = "processing";
})(SubscriptionStatusEnum = exports.SubscriptionStatusEnum || (exports.SubscriptionStatusEnum = {}));
var SubscriptionExtensionPackageStatus;
(function (SubscriptionExtensionPackageStatus) {
    SubscriptionExtensionPackageStatus["PAID"] = "paid";
    SubscriptionExtensionPackageStatus["PENDING"] = "pending";
    SubscriptionExtensionPackageStatus["PAYMENT_FAILED"] = "payment_failed";
    SubscriptionExtensionPackageStatus["EXPIRED"] = "expired";
})(SubscriptionExtensionPackageStatus = exports.SubscriptionExtensionPackageStatus || (exports.SubscriptionExtensionPackageStatus = {}));
var PaymentToolOptions;
(function (PaymentToolOptions) {
    PaymentToolOptions["FENA"] = "fena";
    PaymentToolOptions["STRIPE"] = "stripe";
})(PaymentToolOptions = exports.PaymentToolOptions || (exports.PaymentToolOptions = {}));
var SubscriptionEndOfPeriodProcessingResult;
(function (SubscriptionEndOfPeriodProcessingResult) {
    SubscriptionEndOfPeriodProcessingResult["INVOICE_CREATED"] = "invoice_created";
    SubscriptionEndOfPeriodProcessingResult["INVOICE_CREATED_NO_PAYMENT_METHOD"] = "invoice_created_no_payment_method";
    SubscriptionEndOfPeriodProcessingResult["INVOICE_CREATED_PROVIDER_FAILED"] = "invoice_created_provider_failed";
    SubscriptionEndOfPeriodProcessingResult["CHARGE_ACCEPTED"] = "charge_accepted";
    SubscriptionEndOfPeriodProcessingResult["ZERO_TOTAL"] = "zero_total";
    SubscriptionEndOfPeriodProcessingResult["SKIPPED_OPTED_OUT"] = "skipped_opted_out";
    SubscriptionEndOfPeriodProcessingResult["SKIPPED_ALREADY_INVOICED"] = "skipped_already_invoiced";
    SubscriptionEndOfPeriodProcessingResult["SCHEDULED_CANCELLATION_FINALIZED"] = "scheduled_cancellation_finalized";
    SubscriptionEndOfPeriodProcessingResult["ERROR_BEFORE_INVOICE"] = "error_before_invoice";
})(SubscriptionEndOfPeriodProcessingResult = exports.SubscriptionEndOfPeriodProcessingResult || (exports.SubscriptionEndOfPeriodProcessingResult = {}));
